import React from 'react';
import { Plus, FilterX } from 'lucide-react';
import EventCard from './EventCard';

const EventsGrid = ({
  events,
  onView,
  onEdit,
  onDelete,
  onShare,
  onToggleFeatured,
  searchTerm,
  activeFilter,
  selectedTypes,
  selectedModes,
  onClearFilters,
  onCreateEvent,
  eventTypes,
  eventModes,
  participantTypes,
  eventStatuses,
  userRole
}) => {
  const hasActiveFilters = searchTerm || activeFilter !== 'all' || selectedTypes.length > 0 || selectedModes.length > 0;
  if (events.length === 0) {
    return (
      <div className="bg-white rounded-2xl shadow-lg p-12 text-center border border-gray-100">
        {hasActiveFilters ? (
          <>
            <FilterX size={64} className="mx-auto text-gray-400 mb-4" />
            <h3 className="text-xl font-semibold text-gray-900 mb-2">No events match your filters</h3>
            <p className="text-gray-600 mb-6">Try adjusting your search criteria or clear all filters</p>
            <button
              onClick={onClearFilters}
              className="px-6 py-3 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-xl transition-all duration-200 shadow-lg hover:shadow-xl"
            >
              Clear All Filters
            </button>
          </>
        ) : (
          <>
            <div className="w-16 h-16 bg-gradient-to-r from-blue-100 to-purple-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <Plus size={32} className="text-blue-600" />
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-2">No events created yet</h3>
            <p className="text-gray-600 mb-6">Get started by creating your first event</p>
            <button
              onClick={onCreateEvent}
              className="px-6 py-3 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-xl transition-all duration-200 shadow-lg hover:shadow-xl"
            >
              Create Your First Event
            </button>
          </>
        )}
      </div>
    );
  }

  return (
    <div>
      {hasActiveFilters && (
        <div className="flex justify-between items-center mb-6">
          <div className="text-sm text-gray-600">
            Showing {events.length} event{events.length !== 1 ? 's' : ''}
            {searchTerm && (
              <span> for "<strong>{searchTerm}</strong>"</span>
            )}
          </div>
          <button
            onClick={onClearFilters}
            className="text-blue-600 hover:text-blue-700 font-medium text-sm flex items-center gap-2"
          >
            <FilterX size={16} />
            Clear Filters
          </button>
        </div>
      )}
      
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {events.map(event => (
          <EventCard
            key={event.Event_Id}
            event={event}
            onView={onView}
            onEdit={onEdit}
            onDelete={onDelete}
            onShare={onShare}
            onToggleFeatured={onToggleFeatured}
            eventTypes={eventTypes}
            eventModes={eventModes}
            participantTypes={participantTypes}
            eventStatuses={eventStatuses}
            userRole={userRole}
          />
        ))}
      </div>
    </div>
  );
};

export default EventsGrid;